import React, { useState, useCallback, useEffect } from 'react';
// @mui
import { useParams } from 'react-router';

import Container from '@mui/material/Container';

import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
// routes
import { paths } from 'src/routes/paths';

// _mock

import { _userList, _roles, USER_STATUS_OPTIONS } from 'src/_mock';

import NavSectionHorizontal from 'src/components/nav-section/horizontal/nav-section-horizontal';

// hooks
// components
import Iconify from 'src/components/iconify';

import { useSettingsContext } from 'src/components/settings';
import CustomBreadcrumbs from 'src/components/custom-breadcrumbs';
import { useTable, getComparator } from 'src/components/table';
// types
import { IUserItem, IUserTableFilters, IUserTableFilterValue } from 'src/types/user';
//

import { Iappuser, ICategortItem, ICategortTableFilterValue } from 'src/types/product';

import AppUserChangePassword from './app-user-changepassword-view';
import UserNewEditForm from '../user-new-edit-form';

// import UserNewEditForm from '../user-new-edit-form';

const defaultFilters: IUserTableFilters = {
  name: '',
  role: [],
  status: 'all',
};

// ----------------------------------------------------------------------

const TABS = [
  {
    value: 'General',
    label: 'General',
    icon: <Iconify icon="mdi:card-account-details" width={24} />,
  },
  {
    value: 'Change Password',
    label: 'Change Password',
    icon: <Iconify icon="mdi:key" width={24} />

  },
];

export default function AdminUserEditDetails() {
  const params = useParams();

  const { id } = params;
  const [currentTab, setCurrentTab] = useState('General');

  const handleNavItemClick = (e: any) => {
    const tabTitle = e.target.innerText;
    if (tabTitle === 'General') {
      setCurrentTab('General');
    }

    if (tabTitle === 'Change Password') {
      setCurrentTab('Change password');
    }
  };

  const table = useTable();

  const settings = useSettingsContext();

  const [tableData, setTableData] = useState<Iappuser[]>([]);

  const [filters, setFilters] = useState(defaultFilters);

  const dataFiltered = applyFilter({
    inputData: tableData,
    comparator: getComparator(table.order, table.orderBy),
    filters,
  });

  const handleChangeTab = useCallback((event: React.SyntheticEvent, newValue: string) => {
    setCurrentTab(newValue);
  }, []);
  return (
    <>
      <Container maxWidth={settings.themeStretch ? false : 'lg'}>
        <CustomBreadcrumbs
          heading="Admin User"
          links={[
            { name: 'Dashboard', href: paths.dashboard.root },
            { name: 'List' },
          ]}
          sx={{
            // mb: { xs: 1, md: 2 },
            mb:0

          }}
        />
        <Tabs
          value={currentTab}
          onChange={handleChangeTab}
          sx={{
            // mb: { xs: 2, md: 3 },
            mb:0
          }}
        >
          {TABS.map((tab) => (
            <Tab key={tab.value} label={tab.label} icon={tab.icon} value={tab.value} />
          ))}
        </Tabs>

        {/* {currentTab === 'General' && <UserNewEditForm id={id} />} */}
        {/* {currentTab === 'Change Password' && <AppUserChangePassword id={id} />} */}
      </Container>
    </>
  );
}

// ----------------------------------------------------------------------

function applyFilter({
  inputData,
  comparator,
  filters,
}: {
  inputData: Iappuser[];
  comparator: (a: any, b: any) => number;
  filters: IUserTableFilters;
}) {
  const { name, status, role } = filters;

  const stabilizedThis = inputData.map((el, index) => [el, index] as const);

  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });

  inputData = stabilizedThis.map((el) => el[0]);

  //   if (name) {
  //     inputData = inputData.filter(
  //       (user) => user.username.toLowerCase().indexOf(name.toLowerCase()) !== -1
  //     );
  //   }

  // if (status !== 'all') {
  //     inputData = inputData.filter((user) => user.status === status);
  // }

  // if (role.length) {
  //     inputData = inputData.filter((user) => role.includes(user.role));
  // }

  return inputData;
}
